
import React, { Component } from 'react'
import { Stepper, GetInfo } from '@operations/shared';
import DeleteLostForm from './deleteLostForm';
import { getUserByPhoneApi } from '../../utils/apisConsts';

class DeleteLost extends Component{
    state = {
        componentSteps: [
            {
                title: 'Get User',
                content: <GetInfo apiLink={getUserByPhoneApi} />,
                id: 0,
            }, {
                title: 'Delete Lost',
                content: <DeleteLostForm />,
                id: 1
            },
        ]
    }

    render() {
        const { componentSteps } = this.state;
        return (
            <>
                <Stepper componentSteps={componentSteps} />
            </>
        )
    }
}

export default DeleteLost
